import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

class QuestionConfig extends Model {
  static urlRoot() {
    return '/surveys/question_configs'
  }

  constructor(attr = {}) {
    super(attr)
    makeObservable(this, {
      isArchived: computed,
    })
  }

  get isArchived(): boolean {
    return this.attributes.archived
  }
}

export default QuestionConfig
